module.exports = __webpack_public_path__ + "img/wagon_parked.305e3763.svg";